import { render } from "./App.vue?vue&type=template&id=07e1f980&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=07e1f980&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-07e1f980"

export default script